<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="xrx-alert-popup show fade-in"
  role="alertdialog"
  aria-labelledby="alert-title"
  tabindex="-1">
  <div class="ap-content">
    <!-- circular progress bar -->
    <xrx-circular-progess-bar></xrx-circular-progess-bar>

    <h4 id="alert-title" class="ap-title">{{ progressInfo }}</h4>

    @if (!completed) {
      <div class="ap-primary" [xdaTranslate]="'SDE_PLEASE_DO_NOT10'"></div>
    }

    <!-- Bad email addresses -->
    @if (report.badEmails && report.badEmails.length && completed) {
      <div class="ap-primary" [xdaTranslate]="'SDE_EMAIL_ADDRESSES_WERE'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.badEmails; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- duplicated email addresses -->
    @if (
      report.duplicatedEmails && report.duplicatedEmails.length && completed
    ) {
      <div
        class="ap-primary"
        [xdaTranslate]="'SDE_EMAIL_ADDRESSES_DUPLICATES'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.duplicatedEmails; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- already been invited  -->
    @if (
      report.usersAlreadyInvited &&
      report.usersAlreadyInvited.length &&
      completed
    ) {
      <div class="ap-primary" [xdaTranslate]="'SDE_USERS_HAVE_ALREADY'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersAlreadyInvited; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- users with other subscription -->
    @if (
      report.usersWithOtherSubscription &&
      report.usersWithOtherSubscription.length &&
      completed
    ) {
      <div
        class="ap-primary"
        [xdaTranslate]="'SDE_USERS_ASSOCIATED_ANOTHER'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersWithOtherSubscription; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }
    <!-- users with this subscription -->
    @if (
      report.usersWithThisSubscription &&
      report.usersWithThisSubscription.length &&
      completed
    ) {
      <div
        class="ap-primary"
        [xdaTranslate]="'SDE_USERS_ALREADY_ASSOCIATED'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersWithThisSubscription; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- already been deleted -->
    @if (report.usersDeleted && report.usersDeleted.length && completed) {
      <div class="ap-primary" [xdaTranslate]="'SDE_USERS_DELETED_CANNOT'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersDeleted; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- already been rejected -->
    @if (report.usersRejected && report.usersRejected.length && completed) {
      <div
        class="ap-primary"
        [xdaTranslate]="'SDE_USERS_REJECTED_CANNOT'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersRejected; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- already been suspended -->
    @if (report.usersSuspended && report.usersSuspended.length && completed) {
      <div
        class="ap-primary"
        [xdaTranslate]="'SDE_USERS_SUSPENDED_CANNOT'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersSuspended; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- already been locked -->
    @if (report.usersLocked && report.usersLocked.length && completed) {
      <div class="ap-primary" [xdaTranslate]="'SDE_USERS_LOCKED_CANNOT'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.usersLocked; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    <!-- unknow error -->
    @if (
      report.otherInvalidEmails && report.otherInvalidEmails.length && completed
    ) {
      <div class="ap-primary" [xdaTranslate]="'SDE_USERS_CANNOT_BE2'"></div>
    }
    @if (completed) {
      <div>
        @for (email of report.otherInvalidEmails; track email) {
          <div class="invalid-email-address">
            <span>{{ email }}</span>
          </div>
        }
      </div>
    }

    @if (completed) {
      <div class="ap-buttons">
        <div class="cb">
          <button
            type="button"
            class="xrx-btn btn-secondary-alert"
            (click)="activeModal.close()">
            <span class="btn-label" [xdaTranslate]="buttonText"></span>
          </button>
        </div>
      </div>
    }
    <br />
  </div>
</div>
